export const ADMIN_CONFIRM = 'ADMIN_CONFIRM'
export const ADMIN_SET = 'ADMIN_GET'
export const ADMIN_DELETE = 'ADMIN_DELETE'
export const ADMIN_CHANGE_ACCESS = 'ADMIN_CHANGE_ACCESS'
